exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ol li[data-v-204027c7]::marker{font-weight:400}li[data-v-204027c7]{font-weight:300}.admin-generated[data-v-204027c7] hr{margin-top:15px!important;margin-bottom:15px!important;font-family:ABCFavorit!important}", ""]);

// exports
